"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRdfBlank = isRdfBlank;
exports.isRdfIri = isRdfIri;
exports.isRdfLiteral = isRdfLiteral;
exports.isBlankBinding = isBlankBinding;
function isRdfBlank(e) {
    return e && e.type === "bnode";
}
function isRdfIri(e) {
    return e && e.type === "uri";
}
function isRdfLiteral(e) {
    return e && e.type === "literal";
}
function isBlankBinding(binding) {
    var blank = binding;
    return (blank.blankTrgProp !== undefined ||
        blank.blankTrg !== undefined ||
        blank.blankSrcProp !== undefined ||
        blank.blankSrc !== undefined);
}
